/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'shared';
const componentName = 'avi-page-header';
const prefix = `${moduleName}.${componentName}`;

export const buttonLabelText = `${prefix}.buttonLabelText`;

export const ENGLISH = {
    [buttonLabelText]: 'edit',
};
